<template>
    <div class="favorites-content" :data-salce="triggerSideNavShow">
        <div class="container">
            <div class="operation-wrap d-flex justify-content-between">
                <v-btn class="create-favorite-btn" @click="create_favorite">
                    <v-icon>mdi-plus-circle</v-icon>
                    {{ $TL.newFavorite }}
                </v-btn>
                <v-select
                    class="condit-screen"
                    v-model="favoritesSort.value"
                    :items="favoritesSort.items"
                    item-text="name"
                    item-value="value"
                    :label="$TL.latestUpdate"
                    :outlined="false"
                    single-line
                    dense
                    :menu-props="{ 'nudge-top': -30 }"
                    @change="get_favorites_list_data"
                ></v-select>
            </div>
            <div class="favorites-list-box d-flex flex-wrap" v-if="hasData">
                <collect-card
                    v-for="(item, i) in favoritesList"
                    :key="i"
                    :index="i"
                    :data="item"
                />
            </div>
            <no-medias v-else />
        </div>
    </div>
</template>

<script>
import collectCard from "./components/collect-card";
import noMedias from "./components/no-medias";
import { getFavorites, getUserProfile } from "@/api/interface.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "favorites-content",

    data() {
        return {
            favoritesList: "",
            hasData: true,
            favoritesSort: {
                value: "updated_at",
                items: [
                    { name: this.$TL.latestUpdate, value: "updated_at" },
                    { name: this.$TL.latestCreate, value: "created_at" },
                    { name: this.$TL.fromAtoZ, value: "name" }
                ]
            }
        };
    },
    components: {
        collectCard,
        noMedias
    },
    computed: {
        ...mapState("userCentered", ["userCenteredInfo"]),
        ...mapState("mixins", ["triggerSideNavShow"])
    },
    created() {
        this.get_favorites_list_data();
        this.get_favorites_count_data();

        this.$P.$on("updateFavoritesData", () => {
            this.get_favorites_list_data();
            this.get_favorites_count_data();
        });
    },
    mounted() {},
    methods: {
        ...mapMutations("userCentered", ["updateUserCenteredInfo"]),
        //  获得收藏夹列表信息
        async get_favorites_list_data() {
            let { data } = await getFavorites({
                orderby: this.favoritesSort.value
            });
            this.favoritesList = data;
            this.hasData = this.favoritesList.length ? true : false;

            this.updateUserCenteredInfo({
                fav_count: this.favoritesList.length
            });
        },
        //  获得用户信息
        async get_favorites_count_data() {
            let { data } = await getUserProfile();
            this.updateUserCenteredInfo(data.profile);
        },
        //  打开创建收藏夹弹框
        create_favorite() {
            this.$store.state.vModal.isCreateFavoriteDialogShow = true;
        }
    }
};
</script>

<style lang="scss">
.favorites-content {
    transition: all 0.35s ease;
    &[data-salce="true"] {
        padding-left: 260px;
    }

    .container {
        width: 100%;
        padding: {
            left: 16px;
            right: 16px;
        }
        margin: auto;
    }
    .operation-wrap {
        margin-top: 24px;
        margin-bottom: 20px;
        padding: 0 12px;

        .condit-screen {
            max-width: 100px;
        }

        .v-input__slot {
            justify-content: flex-end;
            &::after,
            &::before {
                display: none;
            }
        }

        .v-select__slot {
            .v-select__selection {
                font-size: 15px;
            }
        }
    }
}
</style>
